import './App.css';
import StartUpPage from './Components/StartUpPage';

function App() {
  return (
    <div className="App">
      <StartUpPage />
    </div>
  );
}

export default App;
